import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage117 from "../../../../assets/PDFViewerImages/PDFViewerImage117.jpg";

const Chapter33 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 33 */}
                <section id="section33" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter33Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter33Paragraph1}

                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage117} alt="Traffic Rules"/>
                    </div>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter33List11}</li>
                        <li>{language.chapter33List12}
                        </li>
                        <li>{language.chapter33List13}</li>
                        <li>{language.chapter33List14}
                        </li>
                        <li>{language.chapter33List15}
                        </li>
                        <li>{language.chapter33List16}</li>
                        <li>{language.chapter33List17}</li>
                        <li>{language.chapter33List18}</li>
                        <li>{language.chapter33List19}</li>
                        <li>{language.chapter33List10}
                        </li>
                        <li>{language.chapter33List111}
                        </li>
                        <li>{language.chapter33List121}
                        </li>
                        <li>{language.chapter33List131}</li>
                        <li>{language.chapter33List141}
                        </li>
                        <li>{language.chapter33List151}</li>
                        <li>{language.chapter33List161}
                        </li>
                        <li>{language.chapter33List171}
                        </li>
                        <li>{language.chapter33List181}</li>

                    </ul>


                </section>

        </>
    )

}

export default Chapter33;
